import { render, staticRenderFns } from "./RespImg.vue?vue&type=template&id=373bf122&lang=pug&"
import script from "./RespImg.vue?vue&type=script&lang=js&"
export * from "./RespImg.vue?vue&type=script&lang=js&"
import style0 from "./RespImg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports